import React from 'react'
import Home from '../components/Home'
import { Container } from './styles'
import * as T from './types'

const App = ({ properties, ...props }: T.AppPropsType) => {
  return (
    <Container>
      <Home
        data-testid="dashboard-home"
        properties={properties}
        {...props}
      />
    </Container>
  )
}

export default App
